/*地图函数工具库*/
import turf from "turf"/*turf库*/
import WKT from "terraformer-wkt-parser"
import RectangleDraw from "../draw_tool/mapbox_gl_draw_rectangle";
import CircleMode from "../expend_draw_tool/mapbox_gl_draw_circle";
import DragCircleMode from "../expend_draw_tool/mapbox_gl_draw_draw_circle";
import customer_draw from "../../../../components/2DMap/draw_tool/customerDraw";
/*wkt解析库*/
let marker_store = [];/*存储通过本工具添加的marker*/
let sys_cur_hilight_feature = ''/*当前高亮feature*/
let sys_hilight_sourceId = "sys_hilight_sourceId";/*系统默认高亮sourceID*/
let sys_hilight_layerId = "sys_hilight_layerId";/*系统默认高亮layerId*/

let sys_hilight_line_style =  {"line-color": '#DEA6DE', "line-opacity": 1, "line-width":4,"line-gap-width":0,"line-blur":0};/*系统默认高亮line样式*/
let sys_hilight_fill_style =  {"fill-color": "yellow", "fill-opacity": 0.5};/*系统默认高亮fill样式*/
let sys_hilight_point_style =  {'circle-radius': 10, 'circle-color': '#3887be'};/*系统默认高亮点样式*/
let qh_hilight_layerIds = [/*资源是区划图层的对应图层ID*/
  {levelName:"省",layerId:"sys_qh_hilight_layer",ori_layer_id:"省域"},
  {levelName:"市",layerId:"sys_qh_hilight_layer",ori_layer_id:"地市域"},
  {levelName:"县",layerId:"sys_qh_hilight_layer",ori_layer_id:"县域"},
  {levelName:"乡",layerId:"sys_qh_hilight_layer",ori_layer_id:"乡镇域"},
  {levelName:"村",layerId:"sys_qh_hilight_layer",ori_layer_id:"村域"},
];

/*当前点击功能对象*/
let cur_click_func = ''

/*获取vue实例*/
let get_main_vue = () => {
  return window.vue
}

/*用于存储map全局点击事件的回调函数*/
let global_map_click_call_back_func = ""
let global_map_click_call_back_func2 = ""

let pending = false
let pending_2 = false

/*说明：行政区定位中，options中能带qhdm必须腰带，否则行政区汇总获取不到去掉代码，不能查询*/


/*参数说明：均是下划线命名方法
  * options:{通用地图配置项参数
  * map:地图实例；
  * is_fit_bounds:是否使用fitBounds定位
  * bound_options：fitBounds 的options
  * zoom:中心定位级别
  * speed:中心定位移动速度
  * sourceId:资源ID
  * layerId:图层ID
  * layer_type :添加图层的类型，（line,和fill,其他类型需要继续开发扩充add_layer函数）
  * layerPaint :添加图层的paint
  *
  * */


/*1.定位类*/

/**
 * 通过feature定位
 * @param feature 需要定位的feautre，支持数组
 * @param options 配置项,默认is_fit_bounds为true
 */
let locate_by_feature = (feature,options_ori = {}) => {
  if(feature instanceof Array){feature = turf.featureCollection(feature) }
  let options = {is_fit_bounds:true}
  Object.assign(options,options_ori)
  if(options.is_fit_bounds){
    let bbox = turf.bbox(feature);
    locate_by_bbox(bbox,options);
    /*locate_by_bounds([[bbox[0],bbox[1]],[bbox[2],bbox[3]]], options)*/
  }else{
    let center = turf.center(feature);
    locate_in_center( [center.geometry.coordinates[0],center.geometry.coordinates[1]],options)
  }
}

/**
 *根据bbox定位
 * @param bbox [lng,lat,lng,lat]
 * @param options_ori
 */
let locate_by_bbox = (bbox,options_ori = {}) => {
  let options = {is_fit_bounds:true}
  Object.assign(options,options_ori)
  locate_by_bounds([[bbox[0],bbox[1]],[bbox[2],bbox[3]]], options)
}

/**
 *通过bounds定位
 * @param bounds 定位bounds [[lng,lat],[lng,lat]]
 * @param options 配置项
 */
let locate_by_bounds = (bounds,options_ori = {} ) => {
  //let options = {bound_options:{padding:150}}

  /*结合定位配置项*/
  let default_locate_options = {padding:10}
  if(typeof(sys_locate_maxzoom) != 'undefined'){
    default_locate_options.maxZoom = sys_locate_maxzoom
  }

  let options = {}
  Object.assign(options,options_ori)

  if(options.bound_options){
    Object.assign(default_locate_options,options.bound_options)
  }
  options.bound_options = default_locate_options

  // let self_options = {bound_options:{padding:150}};
  //Object.assign(self_options,options)
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;

  map.fitBounds(bounds, options.bound_options || '');
}

/**
 *通过中心点加级别定位
 * @param center 中心点 ['经度'，'纬度']
 * @param options 配置项
 */
let locate_in_center = (center,options = {}) => {
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  map.flyTo({
    center:center,
    zoom: options.zoom || 8,
    speed:options.speed ||  1,
  });
}

/**
 * 通过geojson定位
 * @param geojson 需要定位的geojson,支持数组
 * @param options 配置项
 */
let locate_by_geojson = (geojson,options_ori = {}) => {
  let finale_feature = ""
  if(geojson instanceof Array){
    let feature_arr = []
    geojson.forEach(item => {
      feature_arr.push(turf.feature(item))
    })
    finale_feature = feature_arr
  }else{
    finale_feature = turf.feature(geojson);
  }

  let options = {is_fit_bounds:true}
  Object.assign(options,options_ori)
  locate_by_feature(finale_feature,options);
}

/**
 * 通过wkt定位
 * @param wkt 需要定位的wkt
 * @param options 配置项
 */
let locate_by_wkt = (wkt,options_ori = {}) => {
  let options = {is_fit_bounds:true}
  Object.assign(options,options_ori)
  /*处理wkt是数组和非数组的情况*/
  if(wkt instanceof Array){
    let feature_arr = [];
    wkt.forEach(item => {
      feature_arr.push(get_feature_by_wkt(item));
    })
    locate_by_feature(feature_arr ,options);
  }else{
    locate_by_feature(get_feature_by_wkt(wkt) ,options);
  }
}


/**
 * 通过区划代码定位
 * @param wkt 需要定位的区划代码
 * @param options 配置项
 */
let locate_by_qhdm = (qhdm,options_ori = {}) => {
  if(!options_ori.nf && !options_ori.version){
    get_main_vue().GLOBAL.warning('根据区划代码定位需要传入年份或版本')
    return
  }
  options_ori.qhdm = qhdm

  let options = {is_fit_bounds:true}
  Object.assign(options,options_ori)

  /*根据版本获取行政区*/
  if(options.nf){
    get_main_vue().GLOBAL.api_xzq_sz_by_year_data.get_xzq_by_year({nf:options.nf,type:'arr'}).then(res => {
      let cur_xzq = res.find(item =>{return item.qhdm == qhdm})
      if(!cur_xzq.bbox){
        get_main_vue().GLOBAL.warning("行政区四至数据为空，定位失败")
        return
      }
      locate_by_wkt(cur_xzq.bbox,options);
    }).catch(err => {
      get_main_vue().GLOBAL.common_tool.sys_reason_log('根据' + qhdm + '定位，使用' + options.nf + '获取年份行政区数据失败')
    })
  }

  /*根据年份获取行政区*/
  if(options.version){
    get_main_vue().GLOBAL.api_xzq_sz_by_version_data.get_xzq_by_version({version:options.version,type:'arr'}).then(res => {
      let cur_xzq = res.find(item =>{return item.qhdm == qhdm})
      if(!cur_xzq.bbox){
        get_main_vue().GLOBAL.warning("行政区四至数据为空，定位失败")
        return
      }
      locate_by_wkt(cur_xzq.bbox,options);
    }).catch(err => {
      get_main_vue().GLOBAL.common_tool.sys_reason_log('根据' + qhdm + '定位，使用' + options.version + '获取版本行政区数据失败')
    })
  }

}


/*2.解析类*/

/**
 * 解析wkt，返回geojson
 * @param wkt wkt数据
 * @returns {GeometryObject}
 */
let get_geojson_by_wkt = (wkt)  => {
  if(wkt instanceof Array){
    let res = []
    wkt.forEach(item => {res.push(WKT.parse(wkt))})
    return res
  }else{
    return WKT.parse(wkt);
  }
}


/**
 * 解析wkt，返回feature
 * @param wkt wkt wkt数据
 * @returns {*}
 */
let get_feature_by_wkt = (wkt,union = false) => {
  /*
   let bbb=  {
     "type": "Polygon",
     "coordinates": [
       [ [100.0, 0.0], [101.0, 0.0], [101.0, 1.0], [100.0, 1.0], [100.0, 0.0] ],
       [ [100.2, 0.2], [100.8, 0.2], [100.8, 0.8], [100.2, 0.8], [100.2, 0.2] ]
     ]
   }
 */

  let feature = ""
  if(wkt instanceof  Array){
    let temp_feature_arr = []
    wkt.forEach(item => {
      temp_feature_arr.push(turf.feature(WKT.parse(item)))
    })
    if(union){
      feature = turf.featureCollection(temp_feature_arr)
    }else{
      feature = temp_feature_arr
    }

  }else{
    feature = turf.feature(WKT.parse(wkt))
  }

  return feature
}

/*根据geometry返回wkt格式数据*/
let get_wkt_by_geometry = (geo) => {
  if(geo instanceof Array){
    let wkt_arr = [];
    geo.forEach(item => {
      wkt_arr.push(WKT.convert(item))
    })
    return wkt_arr
  }else{
    return WKT.convert(geo)
  }
}

/*根据geome返回wkt格式数据*/
let get_wkt_by_feature = (feature) => {
  if(feature instanceof Array){
    let res = []
    feature.forEach(item => {
      res.push(WKT.convert(item.geometry))
    })
    return res
  }else{
    return WKT.convert(feature.geometry)
  }
}


/*3.图层增删*/

/**
 * 删除图层，支持批量
 * @param layerId 图层ID，可以是数组(即批量)
 * @param options 配置项
 */
let removeLayer = (layerId,options = {}) => {
  if(!layerId){return}
  if(layerId instanceof Array){
    layerId.forEach(item => {
      remove_real_layer(item,options)
    })
  }else{
    remove_real_layer(layerId,options)
  }
}

/**
 * 删除图层，支持批量
 * @param sourceId sourceID，可以是数组(即批量)
 * @param options 配置项
 */
let removeSource = (sourceId,options = {}) => {
  if(!sourceId){return}
  if(sourceId instanceof Array){
    sourceId.forEach(item => {
      remove_real_source(item,options)
    })
  }else{
    remove_real_source(sourceId,options)
  }
}

/*真正删除图层*/
let remove_real_layer = (layerId,options = {}) => {
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  if(map.getLayer(layerId)){
    map.removeLayer(layerId)
  }
}

/*真正删除source*/
let remove_real_source = (sourceId,options = {}) => {
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  if(map.getSource(sourceId)){
    map.removeSource(sourceId)
  }
}


/**
 * 添加影像图层（根据影像服务地址）
 * @param url 影像服务地址
 * @param options 配置项
 */

let add_layer_by_raster = (url,options = {}) => {

  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let sourceId =  options.sourceId || "sys_add_raster_sourceId";

  /*如果已存在layer则清除*/
  let layerId = options.layerId || "sys_add_raster_layerId";
  if(map.getLayer(layerId)){
    map.removeLayer(layerId)
  }

  /*如果有重名source，则移除source*/
  let source_obj = map.getSource(sourceId);

  if(source_obj){
    setTimeout(() => {
      map.removeSource(sourceId)
      setTimeout(() => {
        real_add_layer_by_raster(url,options)
      },10)
    },10)
  }else{
    real_add_layer_by_raster(url,options)
  }
}

/*添加影像服务图层*/
let real_add_layer_by_raster = (url,options = {}) => {

  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let sourceId =  options.sourceId || "sys_add_raster_sourceId";

  /*添加资源*/
  map.addSource(sourceId,{
    type: "raster",
    tileSize: 256,
    tiles: [url],
  });


  /*添加图层*/
  let before_layer_id = options.before_layer_id || ""
  let layerId = options.layerId || "sys_add_raster_layerId";

  map.addLayer({
    'id': layerId,
    'source': sourceId,
    'type': 'raster',
    'paint': options.paint || { 'raster-opacity': 1 }
  },before_layer_id);

}

/*移除影像图片*/
let remove_raster_layer = (options = {}) => {
  let layerId =  options.layerId || "sys_add_raster_layerId"
  remove_real_layer(layerId,options)
}

/*删除图片图层*/
let remove_image_layer = (options = {}) => {
  let layerId =  options.layerId || "sys_add_layer_by_imageId"
  remove_real_layer(layerId,options)
}

/*添加图片图层*/
let add_layer_by_image = (options = {}) => {

  /*根据四至计算坐标*/
  let bounds = options.bounds
  let ws_lng = bounds[0][0]
  let ws_lat = bounds[0][1]
  let en_lng =  bounds[1][0]
  let wn_lat =  bounds[1][1]
  let coordinaets = [[ws_lng,wn_lat], [en_lng,wn_lat], [en_lng,ws_lat], [ws_lng,ws_lat]]

  /*图片地址*/
  let url = options.url

  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let sourceId =  options.sourceId || "sys_add_image_sourceId";

  /*添加source*/
  if(map.getSource(sourceId) ){
    /*更新资源*/
    let source_obj = map.getSource(sourceId);
    /* source_obj.updateImage({url: url})/!*更新图片*!/
     source_obj.setCoordinates(coordinaets);/!*更新位置*!/
 */
    source_obj.updateImage({
      url: url,
      coordinates: coordinaets
    })

  }else{
    /*添加资源*/
    map.addSource(sourceId,{
      type:"image",
      url:url,
      coordinates:coordinaets
    });
  }

  /*添加图层*/
  let before_layer_id = options.before_layer_id || ""
  let layerId = options.layerId || "sys_add_layer_by_imageId";
  if(!map.getLayer(layerId)){
    map.addLayer({
      'id': layerId,
      'source': sourceId,
      'type': 'raster',
      'paint': options.paint || { 'raster-opacity': 1 }
    },before_layer_id);
  }

}

/**
 * 通过feature添加图层
 * @param feature feature数据
 * @param options 配置项
 */
let add_layer_by_feature = (feature,options_ori = {}) => {
  add_source_by_feature(feature,options_ori);/*添加source*/
  let map = options_ori.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  /*如果已经有该图层则不必添加图层，source里已经更新*/
  if(!options_ori.layerId || !map.getLayer(options_ori.layerId)){
    add_layer_from_feature(options_ori);/*添加图层*/
  }
}

/**
 * 通过geojson添加图层
 * @param feature feature数据
 * @param options 配置项
 */
let add_layer_by_geojson = (geojson,options_ori = {}) => {
  let finale_feature = ""
  if(geojson instanceof Array){
    let feature_arr = []
    geojson.forEach(item => {
      feature_arr.push(turf.feature(item))
    })
    finale_feature = feature_arr
  }else{
    finale_feature = turf.feature(geojson);
  }

  add_layer_by_feature(finale_feature,options_ori)
}


/**
 *通过feature添加source
 * @param feature
 * @param options
 */
let add_source_by_feature = (feature,options = {}) => {
  if(feature instanceof Array){feature = turf.featureCollection(feature) }
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let sourceId =  options.sourceId || sys_hilight_sourceId ||  "sys_add_sourceId";
  /*添加source*/
  if(map.getSource(sourceId) ){
    map.getSource(sourceId).setData(feature);
  }else{
    map.addSource(sourceId, {
      "type": "geojson",
      "data":feature,
    });
  }
}

/**
 * 添加图层（资源是geojson）
 * @param options_ori
 */
let
  add_layer_from_feature = (options_ori = {}) => {
  let options = {layer_type:"line"}
  Object.assign(options,options_ori);
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let layerId = options.layerId || sys_hilight_layerId;/*图层ID*/
  let sourceId = options.sourceId ||  sys_hilight_sourceId;/*sourceID*/
  //if(options.replaceLayer && map.getLayer(layerId)){removeLayer(layerId,options)}

  /*is_geo_src是否是geojson数据源*/
  if((map.getLayer(layerId) && !options.is_geo_src) || (map.getLayer(layerId) && map.getLayer(layerId).type != 'line')  ){
    removeLayer(layerId,options)
  }

  let before_layer_id = ""
  if(options.before_layer_id){
    before_layer_id = options.before_layer_id
  }

  /*为等待删除图层后再添加图层，此处延时处理*/
  setTimeout(() => {
    if(!map.getLayer(layerId)){
      let paint = "";
      if(options.layer_type == "line"){paint = options.layerPaint || sys_hilight_line_style}
      if(options.layer_type == "fill"){paint = options.layerPaint ||  sys_hilight_fill_style}
      if(options.layer_type == "circle"){paint = options.layerPaint ||  sys_hilight_point_style}

      map.addLayer({
        "id": layerId,
        "type": options.layer_type,
        "source": sourceId,
        "paint": paint,
      },before_layer_id);
    }
  },500)

}

/**
 * 添加图层（source是服务）
 * @param options_ori
 */
let add_layer_by_vector = (options_ori = {}) => {
  let options = {layer_type:"line"}
  Object.assign(options,options_ori);

  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let layerId = options.layerId || sys_hilight_layerId;/*图层ID*/
  let sourceId = options.sourceId ||  sys_hilight_sourceId;/*sourceID*/
  let sourceLayer = options.sourceLayer ||  sourceId;/*sourceID*/

  if(map.getLayer(layerId)){
    if(map.getLayer(layerId).source != sourceId){
      removeLayer(layerId,options)
    }
  }
  /*为等待删除图层后再添加图层，此处延时处理*/
  setTimeout(() =>{
    let paint = "";
    if(options.layer_type == "line"){paint = options.layerPaint ||  sys_hilight_line_style}
    if(options.layer_type == "fill"){paint = options.layerPaint ||  sys_hilight_fill_style}
    let filter =  options.filter || "";
    /*没有图层则添加图层*/
    if(!map.getLayer(layerId)){
      let layer_params = {
        "id": layerId,
        "type": options.layer_type,
        "source": sourceId,
        "source-layer": sourceLayer,
        "paint": paint,
      }

      if(options.layer_params){
        layer_params=options.layer_params;
      }
      if(filter){
        layer_params.filter = filter
      }

      map.addLayer(
        layer_params,options.before_layer_id || ""
      );

    }else{ /*已有图层则设置filter和paint*/
      Object.keys(paint).forEach(key => {map.setPaintProperty(layerId, key, paint[key]);})
      if(filter){
        map.setFilter(layerId,filter)
      }
    }
  },300)
}

/*4.高亮*/

/**
 * 通过四至高亮
 * @param bounds [[lng,lat],[lng,lat]]
 * @param options
 */
let hilight_by_bounds = (bounds,options_ori = {}) => {

  let geometry = {
    "type":"Polygon",
    "coordinates":[
      [
        [bounds[0][0],bounds[0][1]],
        [bounds[1][0],bounds[0][1]],
        [bounds[1][0],bounds[1][1]],
        [bounds[0][0],bounds[1][1]],
        [bounds[0][0],bounds[0][1]]
      ]
    ]
  }

  let feature = turf.feature(geometry);
  hilight_by_feature(feature,options_ori)
}

/**
 * 通过feature高亮
 * @param feature 支持数组
 * @param options
 */
let hilight_by_feature = (feature,options_ori = {}) => {
  //let options = {layer_type:'line',layerPaint:  {'line-color':'#DEA6DE','line-width':4}}
  let options = {layer_type:'line'}
  sys_cur_hilight_feature = feature
  Object.assign(options,options_ori)
  add_layer_by_feature(feature,options)
}

/**
 * 通过geojson高亮
 * @param geojson 支持数组
 * @param options
 */
let hilight_by_geojson = (geojson,options_ori = {}) => {
  let options = {layer_type:'line',layerPaint:  {'line-color':'#DEA6DE','line-width':4}}
  Object.assign(options,options_ori)

  /*处理geojson是数组和非数组的情况*/
  if(geojson instanceof Array){
    let feature_arr = [];
    geojson.forEach(item => {
      feature_arr.push(turf.feature(item));
    })
    hilight_by_feature(feature_arr ,options);
  }else{
    hilight_by_feature(turf.feature(geojson),options);
  }
}

/**
 * 通过wkt高亮
 * @param wkt 支持数组
 * @param options
 */
let hilight_by_wkt = (wkt,options_ori = {}) => {
  let options = {layer_type:'line',layerPaint: {'line-color':'#DEA6DE','line-width':4}}
  Object.assign(options,options_ori)

  /*处理wkt是数组和非数组的情况*/
  if(wkt instanceof Array){
    let feature_arr = [];
    wkt.forEach(item => {
      feature_arr.push(get_feature_by_wkt(item));
    })
    hilight_by_feature(feature_arr ,options);
  }else{
    hilight_by_feature(get_feature_by_wkt(wkt),options);
  }
}

/**
 * 通过区划代码高亮，支持省市县
 * @param qhdm
 * @param options
 */
let hilight_by_qhdm = (qhdm,options = {}) => {
  sys_cur_hilight_feature = ""

  let qhdm_length = qhdm.toString().length;
  //if(qhdm_length > 6){get_main_vue().GLOBAL.warning("区划代码高亮功能只支持，省，市县");return}
  let xzq_obj = "";
  if(qhdm_length == 2 ){
    xzq_obj = qh_hilight_layerIds.find(item => {return item.levelName == "省"});
  }
  if(qhdm_length == 4 ){
    xzq_obj = qh_hilight_layerIds.find(item => {return item.levelName == "市"});
  }
  if(qhdm_length == 6 ){
    xzq_obj = qh_hilight_layerIds.find(item => {return item.levelName == "县"});
  }

  if(qhdm_length == 9 ){
    xzq_obj = qh_hilight_layerIds.find(item => {return item.levelName == "乡"});
  }

  if(qhdm_length > 9 ){
    xzq_obj = qh_hilight_layerIds.find(item => {return item.levelName == "村"});
    qhdm = qhdm.substr(0,12)//防止村区划代码为19位，与配图不符合
  }

  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let sourceId = map.getLayer(xzq_obj.ori_layer_id).source;
  Object.assign(options,{filter:["==","qhdm",qhdm],sourceId:sourceId});
  add_layer_by_vector(options)
}

/**
 * 清除系统渲染内容
 * @param options
 */
let clear_sys = (options = {layer_id:"",source_d:""}) => {
  clear_sys_hilight();
  removeLayer(options.layerid,options);/*删除layer*/
  removeSource(options.source_d,options);/*删除source*/
}

/**
 * 清除系统高亮
 * @param options
 */
let clear_sys_hilight = (options = {}) => {
  sys_cur_hilight_feature = ""
  removeLayer(sys_hilight_layerId,options);/*删除layer*/
  removeSource(sys_hilight_sourceId,options);/*删除source*/
}


/*5.过滤*/
/**
 * 过滤图层
 * @param layerId
 * @param filter
 * @param options_ori (overlap_roi_filter:true/false; 新的filter是否覆盖原filter，默认为false)
 */
let setFilter = (layerId,filter,options_ori = {}) => {
  let options = {overlap_roi_filter :false}
  Object.assign(options,options_ori)
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let new_filter = filter;
  if(!options.overlap_roi_filter){new_filter = getFilter(layerId,filter)[1]}
  map.setFilter(layerId,new_filter)
}

/**
 *获取追加filter，返回一个长度为2的数组，0是旧的filter，1是新的filter
 * @param layerId  图层ID
 * @param filter  要新增的filter
 * @param ori_filter 旧的filter ，如不传则自动获取当前layer的filter作为旧的filter
 * @param options 配置项
 * @returns {(string|*)[]|(*[]|string)[]|(*[]|*)[]}
 */
let getFilter = (layerId, filter,ori_filter,options = {}) => {
  let map = options.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let oldFilter = ori_filter ||  (layerId ? map.getLayer(layerId).filter : '');
  if (!filter) {
    return [ (oldFilter ? [...oldFilter] : ''), ""]
  }
  let orginFilter = "";
  if (!oldFilter || oldFilter == "undefined") {
    return ["", filter];
  } else {
    orginFilter = [...oldFilter];
  }
  let newFilter = [];
  if (["all", "any"].includes(filter[0])) {
    filter.splice(0, 1);
    newFilter = ["all"];
    if (["all", "any"].includes(orginFilter[0])) {/*通过*/
      /*遍历旧filter，以新filter的ke为准*/
      orginFilter.splice(0, 1);
      let temp = []
      orginFilter.forEach(item => {
        let findIndex = filter.findIndex(itemF => {
          return item[1] === itemF[1] && itemF[0] != "has"
        });
        if (findIndex < 0 || (options.except_prop && options.except_prop .includes(item[1]))) {
          temp.push(item)
        }
      });
      newFilter = ["all", ...filter, ...temp];
    } else {/*通过*/
      let findres = filter.find(itemF => {
        return itemF[1] === orginFilter[1] && itemF[0] != "has"
      });
      if (!findres || (options.except_prop && options.except_prop .includes(orginFilter[1]))) {
        newFilter = ["all", ...filter, orginFilter];
      } else {
        newFilter = ["all", ...filter];
      }
    }
  } else {
    if (["all", "any"].includes(orginFilter[0])) {/*通过*/
      orginFilter.splice(0, 1);
      newFilter = ["all"];
      let findIndex = orginFilter.findIndex(itemF => {
        return itemF[1] === filter[1] && itemF[0] != "has"
      });
      if (findIndex >= 0 && !(options.except_prop && options.except_prop .includes(filter[1]))) {
        orginFilter.splice(findIndex, 1)
      }
      newFilter = ["all", filter, ...orginFilter];
    } else {/*通过*/

      /*except_prop中的属性为新旧属性虽然一样，但是不合并的*/
      if (filter[1] === orginFilter[1] && !(options.except_prop && options.except_prop.includes(filter[1]))) {
        newFilter = filter;
      } else {
        newFilter = ["all", filter, orginFilter];
      }
    }
  }
  return [[...oldFilter], newFilter];
}


/*6.显隐图层*/

/**
 * 显示图层
 * @param layerId
 * @param options_ori
 */
let show_layer = (layerId,options_ori = {}) => {
  if(!layerId){return}
  if(layerId instanceof Array){
    layerId.forEach(item => {
      show_layer_by_id(item,options_ori)
    })
  }else{
    show_layer_by_id(layerId,options_ori)
  }
}

/*根据图层id显示图层*/
let show_layer_by_id = (layerId,options_ori = {}) => {
  if(!layerId){return}
  let map = options_ori.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  if(map.getLayer(layerId)){
    map.setLayoutProperty(layerId,'visibility',"visible");
  }else{
    console.error( "无" + layerId + "图层")
  }
}

/**
 * 隐藏图层
 * @param layerId
 * @param options_ori
 */
let hide_layer = (layerId,options_ori = {}) => {
  if(!layerId){return}
  if(layerId instanceof Array){
    layerId.forEach(item => {
      hide_layer_by_id(item,options_ori)
    })
  }else{
    hide_layer_by_id(layerId,options_ori)
  }
}

/*根据图层id隐藏图层*/
let hide_layer_by_id = (layerId,options_ori = {}) => {
  if(!layerId){return}
  let map = options_ori.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  if(map.getLayer(layerId)){
    map.setLayoutProperty(layerId,'visibility',"none");
  }else{
    console.error( "无" + layerId + "图层")
  }
}


/*获取当前高亮feature*/
let get_cur_hilight_feature = () => {
  return  sys_cur_hilight_feature
}

/**
 * 移动图层
 * @param layer_id 要移动的图层
 * @param reference_id 参考图层id
 * @param options_ori 配置项 其中position为移动到参考图层下面还是上面， 下面传 before ，before也是默认值， 上面传after
 */
let move_layer = (layer_id,reference_id,options_ori = {} ) => {

  let options = {position:'before'}
  Object.assign(options,options_ori)

  let map = options_ori.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  if(options.position == 'before'){
    map.moveLayer(layer_id, reference_id);
  }else{
    let reference_2 = get_before_layer_id(reference_id)
    if(reference_2){
      map.moveLayer(layer_id, reference_2);
    }else{
      map.moveLayer(layer_id);
    }
  }

}

/*根据图层ID获取索引*/
let get_before_layer_id = (map_ori,layer_id) => {
  let map = map_ori ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let layers_arr = map.getStyle().layers
  let index = layers_arr.findIndex(item => {return item.id == layer_id});
  let final_layer = layers_arr[index - 1] || "";
  return final_layer
}

/*根据图层ID获取传入图层的上面一层图层*/
let get_upper_layer_id = (map_ori,layer_id) => {
  let map = map_ori ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let layers_arr = map.getStyle().layers
  let index = layers_arr.findIndex(item => {return item.id == layer_id});
  let final_layer = layers_arr[index + 1] || "";
  return final_layer
}

// 生成uuid任务号
let get_task_id = () => {
  var s = [];
  var hexDigits = "0123456789abcdef";
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = "-";
  var uuid = s.join("");
  return uuid;
}



/*点击事件独占*/
/**
 * 地图点击事件
 * @param call_back 回调函数
 * @param options_ori 配置项
 */
let global_map_click = (call_back,options_ori = {},cursor_pointer = true) => {
  let map = options_ori.map ||  get_main_vue().GLOBAL.common_store.sys_map ;


  if(cur_click_func){
    cur_click_func.inActive()
    cur_click_func = ''
  }

  if(options_ori.clcik_obj){
    cur_click_func = options_ori.clcik_obj
  }else{
    cur_click_func = ''
  }

  /* if(!map.only_id){
     let uuid = get_task_id()
     map.only_id = uuid
     call_back.only_id = uuid
   }else{
     call_back.only_id = map.only_id
   }

   global_map_click_call_back_func.push(call_back)*/

  global_map_click_call_back_func = call_back

  if(cursor_pointer){
    map.getCanvas().style.cursor = 'pointer';
  }
  map.getCanvas().addEventListener("click",handleCanvasClick);
}

/*canvas点击事件*/
let handleCanvasClick = (e) => {
  e.stopPropagation();/*阻事件冒泡*/
  if(global_map_click_call_back_func){global_map_click_call_back_func(e)}
}

/*移除地图点击事件*/
let remove_global_map_click = (call_back,options_ori = {}) => {
  let map = options_ori.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  map.getCanvas().style.cursor = "";
  map.getCanvas().removeEventListener("click",handleCanvasClick);
}

let global_map_click_2 = (call_back, options_ori = {},cursor_pointer = true) => {
  let map = options_ori.map || get_main_vue().GLOBAL.common_store.sys_map;
  if(cursor_pointer){
    map.getCanvas().style.cursor = 'pointer';
  }
  global_map_click_call_back_func2 = call_back
  map.on('click',handleCanvasClick_2)
}

/*canvas点击事件*/
let handleCanvasClick_2 = (e) => {
  /*200ms之内不重复响应*/
  if (pending_2) {
    return
  }

  setTimeout(() => {
    pending_2 = false
  }, 200)

  pending_2 = true

  if (global_map_click_call_back_func2) {
    global_map_click_call_back_func2(e)
  }
}
/*移除地图点击事件*/
let remove_global_map_click_2 = (call_back, options_ori = {}) => {
  let map = options_ori.map || get_main_vue().GLOBAL.common_store.sys_map;
  map.getCanvas().style.cursor = "";
  map.off('click',handleCanvasClick_2)
}

/*7.新增方法  jh */
/*根据图层ID获取上一层的图层*/
let get_before_layer = (map_ori,layer_id)=>{
  let map = map_ori || get_main_vue().GLOBAL.common_store.sys_map;
  if(!map.getLayer(layer_id)){
    return ""
  }
  let layers_arr = map.getStyle().layers;
  let index = layers_arr.findIndex(item => {return item.id == layer_id});
  let final_layer = layers_arr[index - 1];
  return final_layer;
}

/*根据图层ID获取下一层的图层*/
let get_after_layer =(map_ori,layer_id)=>{
  let map = map_ori || get_main_vue().GLOBAL.common_store.sys_map;
  if(!map.getLayer(layer_id)){
    return "";
  }
  let layers_arr = map.getStyle().layers
  let index = layers_arr.findIndex(item => {return item.id == layer_id});
  let final_layer = layers_arr[index + 1];
  return final_layer;
}

/**
 * 添加marker
 * @param lnglat [lng,lat] 位置
 * @param options_ori {map:'地图实例'，marker_id:'marker_id',el:"marker要显示的内容"}
 * @returns {*}
 */
let add_marker = (lnglat,options_ori = {}) => {
  let map = options_ori.map ||  get_main_vue().GLOBAL.common_store.sys_map ;
  let marker_id = options_ori.marker_id || "sys_tool_marker" + Math.random() * 1000 ;

  /*添加marker*/
  let el = options_ori.el || ""
  /*给marker添加click事件，点击显示popup*/
  let cur_marker = new mapboxgl.Marker(el,options_ori.marker_option || {})
    .setLngLat(lnglat)
    .addTo(map);
  cur_marker.marker_id = marker_id
  let temp = marker_store.find(item => {return item.marker_id == marker_id})
  if(temp){
    temp = cur_marker
  }else{
    marker_store.push(cur_marker)
  }
  return cur_marker
}

/*获取marker*/
let get_marker = (layer_id) => {
  let temp = marker_store.find(item => {return item.marker_id == layer_id})
  return temp
}

/*删除marker*/
let remove_marker = (layer_id) => {
  let index = marker_store.findIndex(item => {return item.marker_id == layer_id})
  if(index > -1){
    let marker = marker_store[index]
    marker.remove()
    marker_store.splice(index,1)
  }
}

/*设置paint属性*/
let setPaintProperty = (options) => {
  let layer_id = options.layer_id
  let key = options.key
  let value = options.value
  let map = options.map
  map.setPaintProperty(layer_id, key, value)
}

/*添加map绘制功能*/
let add_map_draw = map => {
  let modes = MapboxDraw.modes;
  modes.draw_rectangle = RectangleDraw;
  modes.drag_circle = DragCircleMode



  /*绘制插件实例*/
  let drawObj = new MapboxDraw({modes:modes,displayControlsDefault: false, controls: {}});

  /*map.on('draw.update_polygon', this.polygon_area)
  map.on('draw.update_line', this.polygon_line)*/

  map.addControl(drawObj);

  let main_draw_obj = new customer_draw({map: map, mapboxDraw: drawObj});
  map.draw = main_draw_obj
}

export default {
  /*1.定位相关*/
  locate_by_feature,/*根据feature定位，feature*/
  locate_by_bbox,  /*根据bbox定位  bbox [lng,lat,lng,lat]*/
  locate_in_center,  /*根据经纬度加中心点定位，[lng，lat]*/
  locate_by_bounds ,/*根据四至定位，[[lng,lat],[lng,lat]]*/
  locate_by_geojson,/*根据geojson定位  geojson*/
  locate_by_wkt ,/*根据wkt定位， wkt*/
  locate_by_qhdm,/*根据区划代码高亮(需要配置对应接口)*/

  /*2.解析转换相关*/
  get_geojson_by_wkt,/*根据给wkt获取json*/
  get_feature_by_wkt,/*根据给wkt获取feature*/
  get_wkt_by_geometry,/*根据geometry获取wkt*/
  get_wkt_by_feature,/*根据feature获取wkt*/

  /*3.地图交互相关*/
  show_layer,/*显示图层，支持数组*/
  hide_layer,/*隐藏图层，支持数组*/
  removeLayer,/*删除图层，支持数组*/
  removeSource,/*删除资源，支持数组*/
  move_layer,/*移动图层*/
  add_layer_by_feature,/*通过feature添加图层*/
  add_layer_by_geojson,/*通过geometry添加图层*/
  add_layer_by_vector,/*根据已有source添加图层*/
  add_source_by_feature:add_source_by_feature,

  add_layer_by_raster,/*添加影像图层*/
  remove_raster_layer,/*删除影像图层*/
  add_layer_by_image,/*添加图片图层*/
  remove_image_layer,/*清除图片图层*/

  hilight_by_feature,/*通过feature高亮，支持数组*/
  hilight_by_bounds,/*通过四至高亮*/
  hilight_by_geojson,/*通过geojson高亮，支持数组*/
  hilight_by_wkt,/*通过wkt高亮，支持数组*/
  hilight_by_qhdm,/*根据区划代码高亮*/
  clear_sys_hilight,/*清除系统高亮*/

  setFilter,/*设置过滤条件，支持是否保留旧的条件*/
  getFilter,/*根据新的filter，返回旧的filter和新旧拼接的filter*/
  setPaintProperty,/*设置paint属性*/

  get_before_layer_id,/*获取某图层id上一层的图层的id*/
  get_upper_layer_id,/*根据图层ID获取传入图层的上面一层图层*/
  get_before_layer,/*根据图层ID获取上一层的图层*/
  get_after_layer,/*根据图层ID获取下一层的图层*/

  /*地图点击事件独占*/
  global_map_click,/*绑定点击事件*/
  remove_global_map_click,/*移除点击事件*/

  add_marker,/*添加marker*/
  get_marker,/*查询marker*/
  remove_marker,/*删除marker*/

  /*这里是绑定地图实例*/
  global_map_click_2,/*绑定点击事件*/
  remove_global_map_click_2,/*移除点击事件*/

  add_map_draw,/*添加map绘制功能*/

}



// WEBPACK FOOTER //
// ./src/assets/js/global_tool/sys_tool/map_tool.js